import SearchOnlyVMBase2 from "Lib/Fs.SmartClient.Client/SearchOnlyVMBase2";
import EditorVMBase from "Lib/Fs.SmartClient.Client/EditorVMBase";
import { useView, autoinject, Container } from 'aurelia-framework'
import FsUtility from "./FsUtility";
export default class SearchVMBase2<T extends EditorVMBase, T2> extends SearchOnlyVMBase2<T, T2> {
    IsSearchAfterSave: boolean;
    IsClearSelectionAfterSave: boolean;

    EditorVMType: new () => T;

    constructor(type: { new(): T; }) {
        super(type);
        this.EditorVMType = type;
    }

    OnSaveSuccess(editorVM: T) {

    }

    UpdateCommand(editorVM: T) {
        var self = this;
        editorVM.validationController.validate({ object: editorVM }).then(result => {
            if (result.valid) {
                editorVM.Save(
                    function () {
                        editorVM.EndEdit();
                        self.OnSaveSuccess(editorVM);

                        if (self.IsSearchAfterSave == true)
                            self.Search();
                        else if (self.IsClearSelectionAfterSave == true) {
                            self.CurrentItem = null;
                            self.SelectedItems = [];
                        }
                    },
                    FsUtility.CommonErrorHandler);
            }
        });
    }

    RemoveCommand(editorVM: T) {
        var searchVM = this;
        if (this.HasEditingChilds)
            return;
        searchVM.RemoveItem(editorVM);
    }

    EditCommand(editorVM: T) {
        var self = this;
        setTimeout(function () {
            if (self.HasEditingChilds)
                return;

            self.SelectNewItem(editorVM);
            editorVM.BeginEdit();
        }, 1)
    }

    CancelCommand(editorVM: T) {
        var searchVM = this;

        if (editorVM == null)
            return;

        if (!editorVM.HasOriginalSource) {
            this.CurrentItem = null;
            this.SelectedItems = [];
            searchVM.RemoveItem(editorVM);
        }
        else
            editorVM.CancelEdit();
    }


    CreateNewItem() {
        if (this.HasEditingChilds)
            return;

        var editorVM = new this.EditorVMType();

        this.AddItem(editorVM);
        this.SelectNewItem(editorVM);

        editorVM.BeginEdit();

        return editorVM;
    };

    OnCurrentChanged(sender, e) {
        this.ClearChildNode();
        if (this.CurrentItem == null) return;

        this.AddChildNode(this.CurrentItem);
        if (this.CurrentItem != null)
            this.CurrentItem.Activate();

    };

    OnCurrentChanging(sender, e) {
        if (this.HasEditingChilds)
            return false;

        return true;
    };

    RemoveItems(items: T[]) {
        throw "This function has not yet been implemented.";
    };

    AddItems(items: T[]) {
        throw "This function has not yet been implemented.";
    };

    AddItem(item: T) {
        this.InitializeAddingItem(item);

        this.SearchResultCollectionView.push(item);
    };

    RemoveItem(item: T) {
        var self = this;
        item.SetIsEditing(false);
        if (item.HasOriginalSource) {
            item.Remove(this, function () {
                self.CurrentItem = null;
                for (var i = 0; i < self.SearchResultCollectionView.length; i++) {
                    if (self.SearchResultCollectionView[i] === item) {
                        self.SearchResultCollectionView.splice(i, 1);
                    }
                }
                self.Search();
            });
        } else {
            self.CurrentItem = null;
            for (var i = 0; i < self.SearchResultCollectionView.length; i++) {
                if (self.SearchResultCollectionView[i] === item) {
                    self.SearchResultCollectionView.splice(i, 1);
                }
            }
            self.Search();
        }
    };

    GetItemIndex = function (i) {
        return this.PageIndex * this.PageSize + i;
    }

    PrepareListViewCollection(list: any[]) { // array list of SearchResult
        this.SearchResultCollectionView = [];

        var editorVMList = [];
        for (var index = 0; index < list.length; index++) { // index for example [0],[1],[2],...,[n]
            var editorVM = new this.EditorVMType();
            this.InitializeLoadingItem(editorVM);
            editorVM.SetOriginalSource(list[index]);
            editorVM.index = this.GetItemIndex(index + 1);
            editorVMList.push(editorVM); // push each record into grid.
        }
        this.SearchResultCollectionView = editorVMList;
    };

    InitializeAddingItem(editorVM: T) {

    };

    InitializeLoadingItem(editorVM: T) {

    };

}
